import IndexRedirect from './AICIIndexRedirect';
import SwitcherLayout from './AICISwitcherLayout';
import Details from './RecommendationDetailsRoot';
import List from './Recommendations';
import Root from './RecommendationsRoot';

export default {
  Root,
  IndexRedirect,
  SwitcherLayout,
  List,
  Details,
};
